import { createFileRoute } from '@tanstack/react-router'
import InstitutionPage from '../../components/pages/InstitutionPage'

export const Route = createFileRoute('/$slug/')({
  component: CareerRender,
})

function CareerRender() {
  const { slug } = Route.useParams()

  return <InstitutionPage slug={slug} />
}
